/* Copyright (c) 2020-present CloudIO Inc */

import { Item } from '../../registry/Component.type';
import { addDays, addHours, startOfDay, startOfHour } from 'date-fns';

export const page: {
  root: Item<'Page'>;
  flexItem: Item<'FlexItem'>;
  flexPanel: Item<'FlexPanel'>;
  localDataStore: Item<'LocalDataStore'>;
  dataStoreReference: Item<'DataStoreReference'>;
} = {
  dataStoreReference: {
    children: ['flexPanel'],
    itemId: 'dataStoreReference',
    parent: 'root',
    props: {
      alias: 'test',
    },
    type: 'DataStoreReference',
  },
  flexItem: {
    children: ['calendar'],
    itemId: 'flexItem',
    parent: 'flexPanel',
    props: {
      backgroundColor: 'paper',
    },
    type: 'FlexItem',
  },
  flexPanel: {
    children: ['flexItem'],
    itemId: 'flexPanel',
    parent: 'dataStoreReference',
    props: {},
    type: 'FlexPanel',
  },
  localDataStore: {
    children: [],
    itemId: 'localDataStore',
    parent: 'root',
    props: {
      alias: 'test',
      data: `Title,From Date,To Date,All Day
Event One,${startOfHour(new Date()).toISOString()},${addHours(
        startOfHour(new Date()),
        1,
      ).toISOString()},false
Full day event,${startOfDay(new Date()).toISOString()},${startOfDay(
        new Date(),
      ).toISOString()},true
Multi day event,${startOfDay(new Date()).toISOString()},${startOfDay(
        addDays(new Date(), 8),
      ).toISOString()},true
`,
      dataSource: 'test',
    },
    type: 'LocalDataStore',
  },
  root: {
    children: ['localDataStore', 'dataStoreReference'],
    itemId: 'root',
    parent: 'root',
    props: {
      windowTitle: {
        type: 'text',
        value: 'Blank Page',
      },
    },
    type: 'Page',
  },
};
